(() => {
  const source = document.currentScript;
  const brand = source.dataset.brandName;
  const support = source.dataset.supportLabel;
  const omitted = 'script,style,textarea,input,code,pre,[data-sb-preserve]';
  const brandPattern = /\bstar[ ._-]?racing\b/gi;
  function brandText(value) {
    let output = value.replace(/[A-Z0-9._%+-]+@starracing\.shop\b/gi, support);
    output = output.replace(/https?:\/\/(?:www\.)?starracing\.shop(?:\/[^\s]*)?/gi, brand);
    output = output.replace(/\bstarracing\.shop\b/gi, brand);
    return output.replace(brandPattern, match => match === match.toUpperCase() ? brand.toUpperCase() : brand);
  }
  function updateText(node) {
    if (!node.parentElement || node.parentElement.closest(omitted)) return;
    const replacement = brandText(node.nodeValue);
    if (replacement !== node.nodeValue) node.nodeValue = replacement;
  }
  function updateElement(element) {
    if (element.closest(omitted)) return;
    for (const name of ['alt', 'title', 'aria-label']) {
      if (!element.hasAttribute(name)) continue;
      const before = element.getAttribute(name);
      const after = brandText(before);
      if (before !== after) element.setAttribute(name, after);
    }
  }
  function updateTree(root) {
    if (root.nodeType === Node.TEXT_NODE) { updateText(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    updateElement(root);
    const texts = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (texts.nextNode()) updateText(texts.currentNode);
    for (const element of root.querySelectorAll('[alt],[title],[aria-label]')) updateElement(element);
  }
  updateTree(document.documentElement);
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') updateText(record.target);
      else if (record.type === 'attributes') updateElement(record.target);
      else for (const node of record.addedNodes) updateTree(node);
    }
  });
  observer.observe(document.documentElement, {
    subtree: true, childList: true, characterData: true,
    attributes: true, attributeFilter: ['alt', 'title', 'aria-label']
  });
})();
